import { useParams } from 'react-router-dom';
import { TitleEntityForm } from '../../features/TitleEntityForm';
import { apiRequests } from '../../shared/api/apiRequests';

/**
 * Группа внутри структуры команды: название и переводы.
 * Группа всегда создаётся в структуре из адреса (:structureId).
 */
const TeamGroupFormPage = () => {
  const { structureId } = useParams();

  return (
    <TitleEntityForm
      load={(groupId) => apiRequests.team.getGroup(structureId, groupId)}
      create={(body) =>
        apiRequests.team.createGroup({ ...body, teamStructureId: Number(structureId) })
      }
      update={apiRequests.team.updateGroup}
      backTo={`/team-structures/${structureId}`}
      placeholder="Например, Дизайн"
      createdText="Группа создана"
      savedText="Группа сохранена"
    />
  );
};

export default TeamGroupFormPage;
